import React, { Component } from 'react';
import {Button, TextField} from '@betareader/design-system';
import { withTranslation } from 'react-i18next';
import { authUtil } from '../../../../utils';

export class CountryGetter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      country: props.initialValue || null,
      searchString: ''
    };
  }

  componentDidMount() {
    this.fetchCountryOptions();
  }

  fetchCountryOptions = async () => {
    const { lng } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/global/countries?lng=${lng || 'en'}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'br-token': idToken
      }
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.error);
        }
        return res.json();
      })
      .then((countryOptions) => {
        if (countryOptions) {
          this.setState({
            countryOptions
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        // done
      });
  }

  handleCountryChange = event => {
    const country = event.target.value || null;
    this.setState({country}, () => {
      if (country) this.submit();
    });
  }

  submit = () => {
    const { country } = this.state;
    if (this.props.onUpdate) {
      this.props.onUpdate({ country })
    }
  }

  // render
  render() {
    const { t, updating, wizardMode } = this.props;
    const { country, countryOptions, searchString } = this.state;
    const visibleOptions = (countryOptions || []).filter(option =>
      option.value === country || option.text.toLowerCase().includes(searchString.toLowerCase()));
    return (
      <div>
        <h2>{t('WhereAreYouFrom')}</h2>
        <p>{t('OnYourProfile')}</p>
        <TextField label={t('Filter')} value={searchString}
          onChange={event => this.setState({searchString: event.target.value})} />
        <label className='br-field'>
          <span className='br-field__label'>{t('Country')}</span>
          <select className='br-field__input' value={country ?? ''}
            onChange={this.handleCountryChange}>
            <option value=''>{t('Country')}</option>
            {visibleOptions.map(option => (
              <option key={option.key || option.value} value={option.value}>
                {option.text}
              </option>
            ))}
          </select>
        </label>
        <Button style={{marginTop: '1em'}} onClick={this.submit}
          disabled={updating} aria-busy={updating}>
          {wizardMode ? (country === null ? t('Skip') : t('Next')) : t('Save')}
        </Button>
      </div>
    );
  }
}

export default withTranslation()(CountryGetter)
